export default __webpack_public_path__ + "static/media/Manrope-Regular.82b079af.ttf";